export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: '「邪娠娼馆」是什么类型的作品？',
    answer: '「邪娠娼馆」是一部暗黑奇幻风格的成人向文学作品，融合了哥特恐怖、情色叙事与心理惊悚元素。作品以一座神秘的娼馆为核心舞台，通过复杂的人物关系与层层递进的剧情，构建了一个关于命运、权力、欲望与自由意志的深邃叙事。它既不是简单的官能小说，也不是传统的奇幻史诗，而是在两者之间开辟了独特的文学空间。',
  },
  {
    question: '这部作品的创作背景是什么？',
    answer: '「邪娠娼馆」诞生于对传统奇幻文学范式的不满与反思。创作者希望打破「奇幻=英雄史诗」的刻板印象，将目光投向那些通常被边缘化的叙事空间——妓院、牢笼、禁忌之地——并在这些空间中寻找人性的极致表达。作品深受哥特文学传统、日本暗黑美学以及现代心理小说的多重影响。',
  },
  {
    question: '如何理解作品中的「契约魔法」体系？',
    answer: '契约魔法是「邪娠娼馆」世界观的核心机制。与传统奇幻中「天赋施法」不同，这里的魔法必须以「代价」换取——血液、记忆、情感、甚至存在本身。这种设计不仅是世界观的设定，更是对「权力必有代价」这一哲学命题的文学化表达。每一种魔法的获得都意味着某种人性部分的丧失。',
  },
  {
    question: '作品中有多少个主要角色？她们的命运走向如何？',
    answer: '作品拥有超过二十个有名有姓的角色，其中核心角色约八人。每个角色的命运都与娼馆的运作机制紧密相连——有人选择屈服、有人选择反抗、有人选择共谋。角色的命运轨迹构成了作品的情感核心，也是读者讨论最热烈的部分。建议从角色图鉴分类开始，逐一了解每个角色的完整故事线。',
  },
  {
    question: '作品的结局是否已经确定？',
    answer: '截至目前的公开信息，故事仍在连载中，最终结局尚未公布。但这恰恰激发了读者群体的想象力——目前已有超过七种主流的结局推论，各自都有文本证据支持。我们建议在阅读完现有章节后，先形成自己的推断，再参考读者讨论区的各种理论，体验多重解读的乐趣。',
  },
  {
    question: '这个网站的内容来源是什么？如何保证分析的准确性？',
    answer: '本站所有内容均由资深读者团队基于原文文本进行系统梳理和深度分析。每篇解析文章都标注了所引用的具体章节和段落，确保分析的透明可追溯。同时，我们也欢迎读者在讨论区提出不同见解——真理越辩越明，多元视角的交锋正是理解复杂作品的最佳方式。',
  },
];